module.exports = __webpack_public_path__ + "static/media/green-arrow-short.a60be180.svg";